export const SALES_TERMS_VERSION = "1.1-2026-09-28";
export const SALES_TERMS_SHA256 = "3d8f23dc382c36cb991a7274d8cd108c799833f71c9579dc93f9c3df4110ead7";
